import {ToastModel} from '@syncfusion/ej2-notifications';

export class ToastSuccesModel implements ToastModel {
  readonly cssClass = 'is-succes';
  icon = 'icon-check-circle';
  title = '';
  width: '300px';
  timeOut: 5000;

  constructor(public content: string, title?: string, iconCss?: string) {
    if (iconCss) {
      this.icon = iconCss;
    }

    if (title) {
      this.title = title;
    }
  }
}
